<template>
  <div>
    <app-header></app-header>
    <div class="app-main">
      <app-silder></app-silder>
      <div class="app-main-inner margin-bottom-20">
        <div class="app-main-middle">
          <div @click="openDialog" class="edit-btn">
            {{ $t("lang.userPage62") }}
          </div>
          <div class="me-form">
            <img :src="userinfo.avatarUrl" />
            <div @click="openAvatarDialog" class="avatar-btn">
              {{ $t("lang.userPage61") }}
            </div>
          </div>
          <div class="me-form">
            <label for="">{{ $t("lang.userPage55") }}：</label>
            <div class="input-val">{{ userinfo.name }}</div>
          </div>
          <div class="me-form">
            <label for="">{{ $t("lang.userPage56") }}：</label>
            <div class="input-val">{{ userinfo.age }}</div>
          </div>
          <div class="me-form">
            <label for="">{{ $t("lang.userPage57") }}：</label>
            <div class="input-val">{{ userinfo.nationality }}</div>
          </div>
          <div class="me-form">
            <label for="">{{ $t("lang.userPage58") }}：</label>
            <div class="input-val">{{ userinfo.introduction }}</div>
          </div>
          <router-link
            v-if="userinfo.status===2"
            tag="a"
            :to="{ path:'/userInfo', query: { teacherid: userinfo.id} }"
            class="changePwd"
          >
            {{ $t("lang.userPage93") }}
          </router-link>
          <div @click="openPwdDialog" class="changePwd">
            {{ $t("lang.userPage59") }}
          </div>
          <div @click="openResumeDialog" class="changePwd">
            {{ $t("lang.userPage60") }}
          </div>
        </div>
      </div>
      <div class="app-main-inner margin-bottom-20">
        <div class="app-main-middle">
          <div class="me-form margin-btttom-0" style="padding-right: 105px;">
            <label for="">{{ $t("lang.userPage67") }}：</label>
            <div
              class="upload-file-name"
              @click="openVideoDialog"
              v-if="userinfo.introVideoUrl"
            >
              {{ $t("lang.userPage68") }}
            </div>
            <el-upload
              class="upload-demo pull-right"
              action=""
              name="videoFile"
              :show-file-list="false"
              :http-request="handleUploadVideo"
              :multiple="false"
              :on-success="handleUploadVideoScucess"
              :before-upload="beforeUploadVideo"
              v-if="!isVideoUpload"
            >
              <div class="me-btn">
                <span>{{ $t("lang.userPage63") }}</span>
              </div>
            </el-upload>
            <div class="upload-status" v-else>
              <div class="upload-progress" v-if="progressVal > 0">
                <div
                  class="upload-progress-bar"
                  :style="{ width: progressVal + '%' }"
                ></div>
              </div>
              <span class="upload-status-text" v-if="progressVal > 0"
                >{{ progressVal }}%</span
              >
              <span class="upload-status-text" v-else>Waiting for upload</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-bg"></div>
    <div class="box dialog-box" v-bind:class="{ fade: isEditfade }">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.userPage69") }}</div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.userPage55") }}</label>
            <input
              type="text"
              :placeholder="$t('lang.userPage55')"
              v-model.trim="userinfoParam.name"
            />
          </div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.userPage56") }}</label>
            <el-date-picker
              v-model="userinfoParam.birthday"
              type="date"
              placeholder="Select Date"
            >
            </el-date-picker>
          </div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.userPage57") }}</label>
            <div class="select-box">
              <b></b>
              <el-select
                v-model="userinfoParam.nationality"
                placeholder="Please select"
              >
                <el-option
                  v-for="item in nationalityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group text-align-left">
            <label for="introduction">{{ $t("lang.userPage58") }}：</label>
            <textarea
              id="introduction"
              cols="30"
              rows="10"
              v-model="userinfoParam.introduction"
            ></textarea>
          </div>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closeDialog">{{
              $t("lang.userPage64")
            }}</a>
            <a class="btn-ok fr" @click="_updateUserInfo">{{
              $t("lang.loginPage15")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isAvatarfade }">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.userPage65") }}</div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.userPage66") }}</label>
            <div class="upload-box">
              <el-upload
                class="img-uploader"
                :action="handleUploadAvatar"
                :headers="handleHeader"
                :show-file-list="false"
                :multiple="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeUploadAvatar"
              >
                <img
                  v-if="userinfoParam.avatarUrl"
                  :src="userinfoParam.avatarUrl"
                  class="previewImage"
                />
                <i v-else class="el-icon-plus img-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closeAvatarDialog">{{
              $t("lang.userPage64")
            }}</a>
            <a class="btn-ok fr" @click="_updateAvatarInfo">{{
              $t("lang.loginPage15")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isPwdfade }">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.userPage73") }}</div>
          <el-form ref="forgotForm" :model="forgotForm" autoComplete="off">
            <div class="form-group text-align-left">
              <label for="" class="width-140">{{
                $t("lang.userPage74")
              }}</label>
              <el-form-item prop="oldPassword">
                <el-input
                  v-model="forgotForm.oldPassword"
                  type="password"
                  :placeholder="$t('lang.userPage74')"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group text-align-left">
              <label for="" class="width-140">{{
                $t("lang.userPage75")
              }}</label>
              <el-form-item prop="newPassword">
                <el-input
                  v-model="forgotForm.newPassword"
                  type="password"
                  :placeholder="$t('lang.userPage75')"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group text-align-left">
              <label for="" class="width-140">{{
                $t("lang.userPage76")
              }}</label>
              <el-form-item prop="checkPass">
                <el-input
                  v-model="forgotForm.checkPass"
                  type="password"
                  :placeholder="$t('lang.userPage76')"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closePwdDialog">{{
              $t("lang.userPage64")
            }}</a>
            <a class="btn-ok fr" @click="editPassword">{{
              $t("lang.loginPage15")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isResumefade }">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.userPage60") }}</div>
          <div class="resume-text">
            <p>{{ $t("lang.userPage70") }}:</p>
            <a class="email-address" href="mailto:t.report@bingotalk.cn"
              >t.report@bingotalk.cn</a
            >
            <span
              v-clipboard="emailAddress"
              @success="clipboardSuccess"
              @error="clipboardError"
              class="fuzhi-btn"
              >{{ $t("lang.userPage71") }}</span
            >
          </div>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closeResumeDialog">{{
              $t("lang.userPage64")
            }}</a>
            <a class="btn-ok fr" @click="closeResumeDialog">{{
              $t("lang.userPage72")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isVideofade }">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.userPage67") }}</div>
          <video :src="videoUrl" class="introVideo" controls></video>
          <div class="form-group">
            <a class="btn-cancel" @click="closeVideoDialog">{{ $t("lang.userPage91") }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import { getToken } from "utils/auth";
import { getNationalityList, updateUserInfo, updatePassword } from "api/me";
import { ERR_OK } from "api/config";
import crypto from "crypto";
let vm = null;

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("lang.loginPage18")));
      } else {
        if (this.forgotForm.newPassword !== "") {
          this.$refs.forgotForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("lang.loginPage19")));
      } else if (value !== this.forgotForm.newPassword) {
        callback(new Error(vm.$t("lang.loginPage20")));
      } else {
        callback();
      }
    };
    return {
      isVideoUpload: false,
      isEditfade: false,
      isAvatarfade: false,
      isPwdfade: false,
      isResumefade: false,
      isVideofade: false,
      videoUrl: "",
      progressVal: 0,
      nationalityList: [],
      emailAddress: "t.report@bingotalk.cn",
      userinfo: {
        id: "",
        introVideoUrl: "",
        videoCdn: "",
        introduction: ""
      },
      userinfoParam: {
        name: "",
        avatarUrl: "",
        birthday: "",
        natinality: "",
        timezone: "",
        socials: "",
        certificate: "",
        passport: "",
        introduction: ""
      },
      handleUploadAvatar: process.env.BASE_API + "/api/v1/upload/avatar",
      handleHeader: {
        Authorization: getToken()
      },
      forgotForm: {
        oldPassword: "",
        newPassword: "",
        checkPass: ""
      },
      forgotFormRules: {
        oldPassword: [
          {
            required: true,
            min: 6,
            max: 14,
            message: this.$t("lang.loginPage11"),
            trigger: "blur"
          }
        ],
        newPassword: [
          { validator: validatePass, trigger: "blur" },
          {
            required: true,
            min: 6,
            max: 14,
            message: this.$t("lang.loginPage11"),
            trigger: "blur"
          }
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  created() {
    vm = this;
    this._getUserInfo();
  },
  activated() {},
  computed: {},
  methods: {
    handleUploadVideo(e) {
      var filename = "";
      var buf = crypto.randomBytes(16);
      for (var i = 0; i < buf.length; ++i) {
        filename += ("0" + buf[i].toString(16)).slice(-2);
      }
      filename +=
        Math.random()
          .toString()
          .slice(2, 10) + ".mp4";
      var geolocation = new window.BMap.Geolocation();
      var self = this;
      var client;
      geolocation.getCurrentPosition(function(r) {
        if (geolocation.getStatus() === window.BMAP_STATUS_SUCCESS) {
          if (/^[\u4e00-\u9fa5]+$/.test(r.address.province)) {
            client = new window.OSS.Wrapper({
              region: "oss-cn-beijing",
              accessKeyId: "LTAIoBoyRxdEVtf9",
              accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
              bucket: "bingotalk-bj",
              secure: true
            });

            client
              .multipartUpload("video/" + filename, e.file, {
                progress: function(p) {
                  return function(done) {
                    self.progressVal = parseInt(p * 100);
                    e.onProgress({ percent: p * 100 });
                    done();
                  };
                }
              })
              .then(function(result) {
                self.videoUrl = filename;
                self.userinfo.videoCdn = "https://bj.static.bingotalk.cn";
                e.onSuccess(result);
              })
              .catch(function(err) {
                e.onError(err);
              });
          } else {
            client = new window.OSS.Wrapper({
              region: "oss-us-west-1",
              accessKeyId: "LTAIoBoyRxdEVtf9",
              accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
              bucket: "bingotalk-sv",
              secure: true
            });

            client
              .multipartUpload("video/" + filename, e.file, {
                progress: function(p) {
                  return function(done) {
                    self.progressVal = parseInt(p * 100);
                    e.onProgress({ percent: p * 100 });
                    done();
                  };
                }
              })
              .then(function(result) {
                self.videoUrl = filename;
                self.userinfo.videoCdn = "https://sv.static.bingotalk.cn";
                e.onSuccess(result);
              })
              .catch(function(err) {
                e.onError(err);
              });
          }
        } else {
          client = new window.OSS.Wrapper({
            region: "oss-us-west-1",
            accessKeyId: "LTAIoBoyRxdEVtf9",
            accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
            bucket: "bingotalk-sv",
            secure: true
          });

          client
            .multipartUpload("video/" + filename, e.file, {
              progress: function(p) {
                return function(done) {
                  self.progressVal = parseInt(p * 100);
                  e.onProgress({ percent: p * 100 });
                  done();
                };
              }
            })
            .then(function(result) {
              self.videoUrl = filename;
              self.userinfo.videoCdn = "https://sv.static.bingotalk.cn";
              e.onSuccess(result);
            })
            .catch(function(err) {
              e.onError(err);
            });
        }
      });
    },
    handleUploadVideoScucess(response, file, fileList) {
      this.userinfo.introVideoUrl = this.videoUrl;
      this._updateVideoInfo();
    },
    _updateVideoInfo() {
      let updateVideoInfo = {
        id: this.userinfo.id,
        videoCdn: this.userinfo.videoCdn,
        introVideoUrl: this.userinfo.introVideoUrl
      };
      updateUserInfo(updateVideoInfo)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.progressVal = 0;
              this.isVideoUpload = false;
              this.$message.success(this.$t("lang.userPage77"));
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code === "200") {
        this.userinfoParam.avatarUrl = response.data.avatarUrl;
      } else {
        this.$message.error(response.message);
      }
    },
    beforeUploadVideo(file) {
      let fileType = true;
      if (["video/mp4"].indexOf(file.type) === -1) {
        this.$message.error(this.$t("lang.userPage78"));
        fileType = false;
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error(this.$t("lang.userPage79"));
        return false;
      }
      this.isVideoUpload = true;
      return isLt2M && fileType;
    },
    beforeUploadAvatar(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      let fileType = true;
      if (
        [
          "application/x-png",
          "image/png",
          "application/x-jpg",
          "image/jpeg"
        ].indexOf(file.type) === -1
      ) {
        this.$message.error(this.$t("lang.userPage80"));
        fileType = false;
      }
      if (!isLt2M) {
        this.$message.error(this.$t("lang.userPage80"));
      }
      return fileType && isLt2M;
    },
    _updateAvatarInfo() {
      let updateVideoInfo = {
        id: this.userinfo.id,
        avatarUrl: this.userinfoParam.avatarUrl
      };
      updateUserInfo(updateVideoInfo)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.$message.success(this.$t("lang.userPage81"));
              this._getUserInfo();
              this.closeAvatarDialog();
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getUserInfo() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.userinfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    },
    _getNationalityList() {
      getNationalityList()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.nationalityList = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _updateUserInfo() {
      let introduction = this.userinfoParam.introduction
        ? this.userinfoParam.introduction
        : "";
      let name = this.userinfoParam.name;
      if (name.length < 1) {
        this.$message.error(this.$t("lang.userPage87"));
        return false;
      }
      if (introduction.length < 4 || introduction.length > 500) {
        this.$message.error(this.$t("lang.userPage30"));
        return false;
      }
      updateUserInfo(this.userinfoParam)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this._getUserInfo();
              this.closeDialog();
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    editPassword() {
      if (!this.forgotForm.oldPassword) {
        this.$message.error(this.$t("lang.userPage82"));
        return false;
      }
      if (this.forgotForm.newPassword) {
        if (
          this.forgotForm.newPassword.length < 6 ||
          this.forgotForm.newPassword.length > 14
        ) {
          this.$message.error(this.$t("lang.userPage83"));
          return false;
        }
      } else {
        this.$message.error(this.$t("lang.userPage84"));
        return false;
      }
      if (this.forgotForm.checkPass) {
        if (
          this.forgotForm.checkPass.length < 6 ||
          this.forgotForm.checkPass.length > 14
        ) {
          this.$message.error(this.$t("lang.userPage85"));
          return false;
        }
        if (this.forgotForm.checkPass !== this.forgotForm.newPassword) {
          this.$message.error(this.$t("lang.userPage86"));
          return false;
        }
      } else {
        this.$message.error(this.$t("lang.loginPage19"));
        return false;
      }
      updatePassword(this.forgotForm)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.$message.success(this.$t("lang.userPage88"));
              this.closePwdDialog();
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    clipboardSuccess(e) {
      this.$message.success(this.$t("lang.userPage89"));
    },
    clipboardError(e) {
      this.$message.error(this.$t("lang.userPage90"));
    },
    openDialog() {
      this.isEditfade = true;
      document.body.setAttribute("class", "dialogfade");
      this._getNationalityList();
      this.userinfoParam = Object.assign({}, this.userinfo);
    },
    closeDialog() {
      this.isEditfade = false;
      document.body.removeAttribute("class", "dialogfade");
      this.userinfoParam.avatarUrl = "";
    },
    openAvatarDialog() {
      this.isAvatarfade = true;
      document.body.setAttribute("class", "dialogfade");
    },
    closeAvatarDialog() {
      this.isAvatarfade = false;
      document.body.removeAttribute("class", "dialogfade");
      this.userinfoParam.avatarUrl = "";
    },
    openVideoDialog() {
      this.isVideofade = true;
      this.videoUrl = this.userinfo.introVideoUrl;
    },
    closeVideoDialog() {
      this.isVideofade = false;
      this.videoUrl = "";
    },
    openPwdDialog() {
      this.isPwdfade = true;
      document.body.setAttribute("class", "dialogfade");
    },
    closePwdDialog() {
      this.isPwdfade = false;
      this.forgotForm = {
        oldPassword: "",
        newPassword: "",
        checkPass: ""
      };
      document.body.removeAttribute("class", "dialogfade");
    },
    openResumeDialog() {
      this.isResumefade = true;
      document.body.setAttribute("class", "dialogfade");
    },
    closeResumeDialog() {
      this.isResumefade = false;
      document.body.removeAttribute("class", "dialogfade");
    }
  },
  components: {
    AppHeader,
    AppSilder
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-middle {
  padding: 20px 30px;
}
.upload-demo {
  display: inline-block;
}
.width-140 {
  width: 140px !important;
}
.me-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  border: 1px solid $baseColor;
  background: rgba(255, 164, 56, 0.5);
  color: #fff;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -13px;
  input[type="file"] {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
  }
}
.up-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  border: 1px solid $baseColor;
  background: rgba(255, 164, 56, 0.5);
  color: #333;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 1;
}
.resume-text {
  margin-bottom: 40px;
  .email-address {
    color: #ffa438;
    user-select: text;
    cursor: pointer;
  }
  .fuzhi-btn {
    margin-left: 10px;
    color: #ff6868;
    cursor: pointer;
    font-size: 14px;
  }
}
.upload-status {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
  width: 150px;
  height: 19px;
  .upload-progress {
    width: 100px;
    height: 3px;
    background-color: #dedede;
    border-radius: 10px;
    position: absolute;
    top: 8px;
    left: 0px;
    z-index: 1;
    overflow: height;
    .upload-progress-bar {
      position: absolute;
      height: 3px;
      transition-delay: 0s;
      transition-duration: 0.6s;
      transition-property: width;
      transition-timing-function: ease;
      background-color: #ffa438;
    }
  }
  .upload-status-text {
    float: right;
    color: #ffa438;
    line-height: 19px;
    span {
      i {
        font-style: normal;
      }
    }
  }
}

.edit-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  border: 1px solid $baseColor;
  background: rgba(255, 164, 56, 0.5);
  color: #fff;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 1;
}
.avatar-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  border: 1px solid $baseColor;
  background: rgba(255, 164, 56, 0.5);
  color: #fff;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  position: absolute;
  top: 8px;
  left: 50px;
  z-index: 1;
}
.me-form {
  @include clearfix;
  margin-bottom: 20px;
  position: relative;
  img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
  }
  label {
    width: 100px;
    color: #333;
  }
  .input-val {
    display: inline-block;
    width: 800px;
    float: right;
    color: #4d4d4d;
    @include wrapping;
  }
  .upload-file-name {
    width: 75px;
    height: 26px;
    line-height: 26px;
    border: 1px solid $baseColor;
    background: rgba(255, 164, 56, 0.5);
    color: #333;
    text-align: center;
    border-radius: 20px;
    cursor: pointer;
    position: absolute;
    top: -4px;
    left: 130px;
    z-index: 1;
  }
  .class-plan-table {
    width: 100%;
    border-right: 1px solid #bebebe;
    border-bottom: 1px solid #bebebe;
    margin: 20px auto;
    border-collapse: collapse;
    border-spacing: 0;
    td {
      border-top: 1px solid #bebebe;
      border-left: 1px solid #bebebe;
    }
    td,
    th {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 15px;
      font-weight: normal;
      padding: 0;
    }
  }
  .time-zoom {
    font-size: 15px;
    color: #bebebe;
  }
}
.changePwd {
  color: #ffa438;
  margin-top: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.form-group {
  margin-bottom: 20px;
  label {
    width: 100px;
    float: left;
    height: 36px;
    line-height: 36px;
    color: #333;
    font-size: 14px;
  }
  input {
    width: 260px;
    float: right;
    height: 36px;
    background-color: #f5f5f5;
    border: 0;
    border-radius: 20px;
    padding: 0px 20px;
    outline: none;
    color: #1d1d1d;
  }
  textarea {
    width: 260px;
    float: right;
    background-color: #f5f5f5;
    border: 0;
    border-radius: 20px;
    padding: 20px;
    outline: none;
    color: #1b1b1b;
    resize: none;
    height: 140px;
  }
  ::-webkit-input-placeholder {
    color: #bebebe;
  }
  .select-box {
    width: 300px;
  }
  .el-form-item {
    width: 260px;
  }
}
.btn-cancel {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: #ccc;
  box-shadow: 2px 3px 0 0 #b1b1b1;
  font-size: 15px;
  border: 1px solid #ccc;
  &:hover {
    background-color: $white;
    color: #ccc;
  }
}
.btn-ok {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: $baseColor;
  box-shadow: 2px 3px 0 0 #ca730c;
  font-size: 15px;
  border: 1px solid $baseColor;
  &:hover {
    background-color: $white;
    color: $baseColor;
  }
}
.introVideo {
  display: block;
  width: 400px;
  height: 400px;
  margin: 0 auto 20px;
}
.dialog-box {
  .dialog-info {
    width: 400px;
    margin: 0 auto;
    padding: 20px 50px;
  }
}
.el-form-item__content {
  width: 260px;
  float: right;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/me/me.vue